import { App } from './app/index.js';
import './sync/events.js';     // registers LW event handlers

document.addEventListener('DOMContentLoaded', () => {

    if (!window.__checkinBooted) {
        window.__checkinBooted = true;
        App.boot();
    }

}, { once: true });
